import { render, staticRenderFns } from "./TrangDanhSachChucVu.vue?vue&type=template&id=39b2f01f&"
import script from "./TrangDanhSachChucVu.vue?vue&type=script&lang=js&"
export * from "./TrangDanhSachChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports